import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_ENDPOINT} from "../config";
import {useAuth} from "../auth/AuthContext";
import changelog from "../data/changelog.json";
import {useRecentGenerations, formatRecentGeneration} from "../components/RecentGenerations";

// Reclama pentru functionalitati - editabil usor, fara sa umble in restul componentei.
// culoare stabila pe pozitie (nu random-pe-fiecare-randare - altfel ar palpai la orice re-render)
const DOT_COLORS = ["#378ADD", "#1D9E75", "#EF9F27", "#E24B4A", "#7F77DD", "#D85A30", "#D4537E"];
const colorForIndex = (i) => DOT_COLORS[i % DOT_COLORS.length];

// Afisam minute rotunjite, nu secunde: variatia reala intre doua build-uri
// (cache rece/cald, incarcarea serverului) e de zeci de secunde, deci "4 min 37 s"
// ar arata ca o promisiune exacta pe care n-o putem tine.
const formatTypicalDuration = (seconds) => {
    if (seconds < 90) {
        return "sub un minut";
    }

    return `~${Math.round(seconds / 60)} minute`;
};

const FEATURES = [
    {
        icon: "fa-images",
        color: "success",
        title: "Gestiune imagini slideshow",
        description: "Adaugă, șterge sau reordonează imaginile din slideshow-ul APK direct din cont, fără o nouă generare de cod.",
    },
    {
        icon: "fa-link",
        color: "info",
        title: "Link opțional pe fiecare imagine",
        description: "Fiecare imagine din slideshow poate avea un buton către o pagină sau ofertă externă, cu nume personalizat.",
    },
    {
        icon: "fa-mobile-alt",
        color: "warning",
        title: "Nume și iconiță personalizate",
        description: "Numele afișat sub iconița aplicației, iconița și splash screen-ul se generează automat din branding-ul companiei.",
    },
];

export default function Dashboard() {
    const {auth} = useAuth();
    const isAuthenticated = !!auth?.token;
    const [stats, setStats] = useState({
        companies: 0,
        companiesWithImages: 0,
        images: 0,
        companiesWithApk: 0,
        // null = inca n-avem destule generari reusite ca sa dam o estimare
        apkTypicalSeconds: null,
        totalSuccessfulGenerations: 0,
    });
    // cat timp userul e logat, "Apk generate" arata totalul PROPRIU (suma companiilor lui),
    // nu statistica globala publica din /stats
    const [ownSuccessfulGenerations, setOwnSuccessfulGenerations] = useState(null);
    const recentGenerations = useRecentGenerations();

    useEffect(() => {
        axios.get(`${API_ENDPOINT}/v1/stats`)
            .then(({data}) => setStats(data))
            .catch(() => { /* dashboard-ul ramane pe 0 daca /stats esueaza */ });
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            setOwnSuccessfulGenerations(null);
            return;
        }
        axios.get(`${API_ENDPOINT}/v1/me`, {headers: {Authorization: `Bearer ${auth.token}`}})
            .then(({data}) => {
                const total = (data.companies || []).reduce((sum, c) => sum + (c.successfulGenerationsCount || 0), 0);
                setOwnSuccessfulGenerations(total);
            })
            .catch(() => setOwnSuccessfulGenerations(null));
    }, [isAuthenticated, auth?.token]);

    const apkGenerateValue = isAuthenticated && ownSuccessfulGenerations !== null
        ? ownSuccessfulGenerations
        : stats.totalSuccessfulGenerations;

    return (
            <div>
                {/* Content Wrapper. Contains page content */}
                <div className="content-wrapper">
                    {/* Content Header (Page header) */}
                    <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">App.WebNou.Ro Dashboard</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">App.WebNou.Ro Dashboard</li>
                            </ol>
                        </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                    </div>
                    {/* /.content-header */}

                    {/* Main content */}
                    <section className="content">
                        <div className="container-fluid">
                            {/* Info boxes - statistici GLOBALE pe toata platforma */}
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-3">
                                    <div className="info-box">
                                        <span className="info-box-icon bg-info elevation-1"><i
                                            className="fas fa-building"></i></span>

                                        <div className="info-box-content">
                                            <span className="info-box-number" style={{fontSize: 28}}>{stats.companies}</span>
                                            <span className="info-box-text" style={{fontSize: 12}}>Companii</span>
                                        </div>
                                        {/* /.info-box-content */}
                                    </div>
                                    {/* /.info-box */}
                                </div>
                                {/* /.col */}
                                <div className="col-12 col-sm-6 col-md-3">
                                    <div className="info-box mb-3">
                                        <span className="info-box-icon bg-danger elevation-1"><i
                                            className="fas fa-images"></i></span>

                                        <div className="info-box-content">
                                            <span className="info-box-number" style={{fontSize: 28}}>{stats.companiesWithImages}</span>
                                            <span className="info-box-text" style={{fontSize: 12}}>Cu imagini</span>
                                        </div>
                                        {/* /.info-box-content */}
                                    </div>
                                    {/* /.info-box */}
                                </div>
                                {/* /.col */}
                                <div className="col-12 col-sm-6 col-md-3">
                                    <div className="info-box mb-3">
                                        <span className="info-box-icon bg-success elevation-1"><i
                                            className="fas fa-photo-video"></i></span>

                                        <div className="info-box-content">
                                            <span className="info-box-number" style={{fontSize: 28}}>{stats.images}</span>
                                            <span className="info-box-text" style={{fontSize: 12}}>Total imagini</span>
                                        </div>
                                        {/* /.info-box-content */}
                                    </div>
                                    {/* /.info-box */}
                                </div>
                                {/* /.col */}

                                {/* fix htmlFor small devices only */}
                                <div className="clearfix hidden-md-up"></div>

                                <div className="col-12 col-sm-6 col-md-3">
                                    <div className="info-box mb-3">
                                        <span className="info-box-icon bg-warning elevation-1"><i
                                            className="fas fa-mobile-alt"></i></span>

                                        <div className="info-box-content">
                                            <span className="info-box-number" style={{fontSize: 28}}>{apkGenerateValue}</span>
                                            <span className="info-box-text" style={{fontSize: 12}}>{isAuthenticated ? "Apk generate (firmele tale)" : "Apk generate"}</span>
                                        </div>
                                        {/* /.info-box-content */}
                                    </div>
                                    {/* /.info-box */}
                                </div>
                                {/* /.col */}
                            </div>
                            {/* /.row */}

                            {/* Timp tipic de generare - raspunde la intrebarea pe care
                                si-o pune vizitatorul ("cat dureaza?"). Ascuns complet cat
                                timp n-avem destule date: mai bine nimic decat o promisiune
                                bazata pe una-doua generari. */}
                            {stats.apkTypicalSeconds !== null && stats.apkTypicalSeconds !== undefined && (
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <div className="callout callout-info mb-0 d-flex align-items-center">
                                            <i className="far fa-clock mr-3" style={{fontSize: 22}}></i>
                                            <span style={{wordBreak: "break-word"}}>
                                                De la cerere până la APK-ul aplicatiei ANDROID descărcabil, durează în mod obișnuit{" "}
                                                <strong>{formatTypicalDuration(stats.apkTypicalSeconds)}</strong>.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Pitch / misiune - text editabil aici */}
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="text-white-50" style={{fontSize: 17, lineHeight: 1.7}}>
                                        <strong className="text-white">App.WebNou.Ro</strong> își propune să ajute firmele și persoanele interesate să aibă acces la diverse servicii, printre care generarea rapidă și ușoară a unei aplicații mobile minimale, care permite prezentarea unor imagini cu reclame și linkuri către website-ul propriu sau alte adrese URL. Utilă pentru evenimente precum teatru sau concerte, artiști, soluții tehnice, prezentări de produse sau campanii electorale — App.WebNou.Ro este ceea ce de mult ar fi trebuit să fie disponibil.
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                            <div className="col-12 col-md-6">
                                {/* Generari recente - deasupra "Ce e nou", in aceeasi coloana */}
                                <div className="card card-outline card-warning">
                                    <div className="card-header">
                                        <h3 className="card-title">Generări aplicație mobilă recente</h3>
                                    </div>
                                    <div className="card-body p-0">
                                        {recentGenerations.length === 0 ? (
                                            <p className="text-muted p-3 mb-0">Nicio generare încă.</p>
                                        ) : (
                                            <ul className="list-group list-group-flush">
                                                {recentGenerations.map((item, i) => (
                                                    <li className="list-group-item" key={i}>{formatRecentGeneration(item)}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* CE E NOU - reclama functionalitati */}
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Ce e nou</h3>

                                        <div className="card-tools">
                                            <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                                <i className="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body p-0">
                                        <ul className="products-list product-list-in-card pl-2 pr-2">
                                            {FEATURES.map((f, i) => (
                                                <li className="item" key={i}>
                                                    <div className="product-img">
                                                        <span
                                                            className={`btn btn-${f.color} rounded-circle`}
                                                            style={{width: 42, height: 42, padding: 0, display: "inline-flex", alignItems: "center", justifyContent: "center"}}
                                                        >
                                                            <i className={`fas ${f.icon}`}></i>
                                                        </span>
                                                    </div>
                                                    <div className="product-info">
                                                        <span className="product-title">{f.title}</span>
                                                        <span className="product-description">{f.description}</span>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    {/* /.card-body */}
                                    <div className="card-footer text-center">
                                        <a href="#/admin">Gestionează imaginile companiei tale</a>
                                    </div>
                                    {/* /.card-footer */}
                                </div>
                                {/* /.card */}
                            </div>

                            <div className="col-12 col-md-6">
                                {/* ULTIMELE COMMIT-URI */}
                                <div className="card card-outline card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Ultimele actualizări</h3>

                                        <div className="card-tools">
                                            <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                                <i className="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body p-0">
                                        {changelog.length === 0 ? (
                                            <p className="text-muted p-3 mb-0">Nicio actualizare recentă.</p>
                                        ) : (
                                            <ul className="list-group list-group-flush">
                                                {changelog.slice(0, 3).map((c, i) => (
                                                    <li className="list-group-item" key={i}>
                                                        <div className="d-flex align-items-start">
                                                            <span
                                                                style={{width: 10, height: 10, borderRadius: "50%", background: colorForIndex(i), flex: "none", marginTop: 5, marginRight: 8}}
                                                            ></span>
                                                            <div className="d-flex justify-content-between align-items-start flex-grow-1">
                                                                <div style={{minWidth: 0, wordBreak: "break-word"}}>
                                                                    {Array.isArray(c.message) ? (
                                                                        <ul className="pl-3 mb-0">
                                                                            {c.message.map((line, j) => (
                                                                                <li key={j}>{line}</li>
                                                                            ))}
                                                                        </ul>
                                                                    ) : (
                                                                        <span>{c.message}</span>
                                                                    )}
                                                                </div>
                                                                <small className="text-muted text-nowrap ml-2">{c.date}</small>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                                {changelog.length > 3 && (
                                                    <>
                                                        <li className="list-group-item text-center text-muted">...</li>
                                                        <li className="list-group-item" key="oldest">
                                                            <div className="d-flex align-items-start">
                                                                <span
                                                                    style={{width: 10, height: 10, borderRadius: "50%", background: colorForIndex(changelog.length - 1), flex: "none", marginTop: 5, marginRight: 8}}
                                                                ></span>
                                                                <div className="d-flex justify-content-between align-items-start flex-grow-1">
                                                                    <div style={{minWidth: 0, wordBreak: "break-word"}}>
                                                                        {Array.isArray(changelog[changelog.length - 1].message) ? (
                                                                            <ul className="pl-3 mb-0">
                                                                                {changelog[changelog.length - 1].message.map((line, j) => (
                                                                                    <li key={j}>{line}</li>
                                                                                ))}
                                                                            </ul>
                                                                        ) : (
                                                                            <span>{changelog[changelog.length - 1].message}</span>
                                                                        )}
                                                                    </div>
                                                                    <small className="text-muted text-nowrap ml-2">{changelog[changelog.length - 1].date}</small>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </>
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/*/.card */}
                            </div>
                            </div>
                            {/* /.row */}

                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="text-white-50" style={{fontSize: 17, lineHeight: 1.7}}>
                                        Fișierul APK generat se poate trimite colaboratorilor și instala pe orice telefon Android. La solicitarea dumneavoastră, îl putem publica contra cost în Magazinul Play, valabil 365 de zile. În curând și pentru telefoanele iOS.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/*/. container-fluid */}
                    </section>
                    {/* /.content */}
                </div>
                {/* /.content-wrapper */}
            </div>
    );
}
